import { render, staticRenderFns } from "./RoomMultipleRegisterExampleModal.vue?vue&type=template&id=f7dca1c4&lang=pug"
import script from "./RoomMultipleRegisterExampleModal.vue?vue&type=script&lang=ts"
export * from "./RoomMultipleRegisterExampleModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports